import SettingsLayout from "../Layout";

import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import GeneralTab from "./Tabs/General";
import GoogleCalendarTab from "./Tabs/Google";


  const tabContent = [
    {panel: "general", content: <GeneralTab />},
    {panel: "google_calendar", content: <GoogleCalendarTab />},
  ]

const CalendarSettings = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Google Calendar", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <SettingsLayout title="Calendar" identifier="invoice_id" tabs={tabs} tabContent={tabContent} url="settings/calendar">

    </SettingsLayout>
  )
};

export default CalendarSettings;